module.exports = __webpack_public_path__ + "img/photo-10.a16fcce3.jpg";